(function () {
  function init(root) {
    const input = root.querySelector('[data-ks-dm-input]');
    const tabs = Array.from(root.querySelectorAll('[data-ks-dm-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-ks-dm-panel]'));

    const getActivePanel = () => panels.find(p => p.classList.contains('is-active'));

    function setActive(key) {
      tabs.forEach(t => {
        const on = t.dataset.ksDmTab === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      panels.forEach(p => p.classList.toggle('is-active', p.dataset.ksDmPanel === key));
      // NOTE: do NOT call filter() here anymore.
      // Filtering is handled by filterAllAndMaybeSwitch() on input.
    }

    // Filter ALL panels and auto-switch to a tab that has matches
    function filterAllAndMaybeSwitch(q) {
      const query = (q || '').trim().toLowerCase();

      function filterPanel(panelKey) {
        const panel = panels.find(p => p.dataset.ksDmPanel === panelKey);
        if (!panel) return 0;

        const cards = Array.from(panel.querySelectorAll('.ks-dm__card'));
        let matches = 0;

        cards.forEach(card => {
          const title = (card.dataset.title || '').toLowerCase();
          const show = !query || title.includes(query);
          card.style.display = show ? '' : 'none';
          if (show) matches++;
        });

        return matches;
      }

      // Filter every panel so we can decide which tab should be active
      const counts = {
        popular: filterPanel('popular'),
        regional: filterPanel('regional'),
        all: filterPanel('all'),
      };

      // If empty input, reset to Popular and show everything there
      if (!query) {
        setActive('popular');
        return;
      }

      // If current tab still has matches, stay on it
      const activeKey = getActivePanel()?.dataset.ksDmPanel;
      if (activeKey && counts[activeKey] > 0) return;

      // Otherwise switch to the first tab that has matches (priority order)
      const order = ['popular', 'regional', 'all'];
      const next = order.find(k => counts[k] > 0);
      if (next) setActive(next);
    }

    tabs.forEach(btn => {
  btn.addEventListener('click', () => {
    setActive(btn.dataset.ksDmTab);
  });
});

    if (input) input.addEventListener('input', e => filterAllAndMaybeSwitch(e.target.value));

    // default tab
    setActive('popular');
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ks-dm]').forEach(init);
  });
})();